const newsletter = {
    input: "js-newsletterInput",
    note: "js-newsletterNote",
    form: "js-newsletterForm",
    submit: "js-newsletterSubmit",
    init: function () {
        this.input = document.getElementById(this.input);
        this.note = document.getElementById(this.note)
        this.form = document.getElementById(this.form)
        this.submit = document.getElementById(this.submit)

        this.input.addEventListener('click', () => {
            this.note.classList.add('visible')
        })

        this.form.addEventListener("submit", function(){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : 'UA',
                'eventCategory' : 'lead_email',
                'eventAction' : 'subscribe',
                'eventLabel' : 'news_offers_style'
            });
        });

        this.input.addEventListener('input', () => {
            this.submit.disabled = !validateEmail(this.input.value);
        });

    }
}

function validateEmail(email) {
    const re = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return re.test(email);
}


newsletter.init()